var path = '/app/components/account-widget/account-widget.html';
var html = "<div class=\"account-widget d-flex flex-row\" ng-class=ctrl.gradient> <div class=\"col-auto d-flex align-items-center\"> <i class=\"fa fa-2x\" ng-class=ctrl.icon aria-hidden=true></i> </div> <div class=\"col d-flex flex-column\"> <h3>{{ ctrl.lineOne }}</h3> <h5>{{ ctrl.lineTwo }}</h5> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account-widget/account-widget.html
// module id = 412
// module chunks = 0